import { getEntry } from "../lib/content.server.js";
import { buildMeta } from "../lib/seo.js";
import Prose from "../components/Prose/Prose.jsx";

export async function loader() {
  const page = getEntry("pages", "privacy-policy");
  if (!page) throw new Response("Not Found", { status: 404 });
  return { page };
}

export function meta() {
  return buildMeta({
    title: "Privacy Policy",
    description: "How RDV Systems collects, uses and protects information on this website.",
    path: "/privacy-policy",
  });
}

export default function PrivacyPolicy({ loaderData }) {
  return (
    <section className="section">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="lead">Last updated {loaderData.page.updated || loaderData.page.date}.</p>
        <Prose html={loaderData.page.html} />
      </div>
    </section>
  );
}
